export default "__VITE_ASSET__CeT51SOV__"